import script from "./BaseTableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTableRow.vue?vue&type=script&setup=true&lang=js"

import "./BaseTableRow.vue?vue&type=style&index=0&id=4b58e0ba&lang=scss&scoped=true"
script.__scopeId = "data-v-4b58e0ba"

export default script